import React, { memo, useEffect, useState } from "react";
import { BookingLabel } from "../../../../../../types/VenueGroup";
import SelectionButton from "../../../../../Shared/Buttons/SelectionButton/SelectionButton";
import { AssignedBookingLabelsType, updateLabelsData } from "./ManageLabels";

type ButtonListType = {
  assignedLabels?: AssignedBookingLabelsType;
  data: BookingLabel[];
  onChange: (assignedLabels: AssignedBookingLabelsType) => void;
  noRecords: string;
};

const ButtonList = ({
  assignedLabels,
  data,
  onChange,
  noRecords
}: ButtonListType) => {
  const [updatedData, setUpdatedData] = useState<
    AssignedBookingLabelsType | undefined
  >(assignedLabels);

  useEffect(() => {
    onChange(updatedData ?? []);
  }, [updatedData]);

  const buttons = data.map((label, i) => (
    <div key={`${label.id}-${i}`} className="ManageLabelButton shrink-0">
      <SelectionButton
        text={label.label}
        data={label.id}
        selected={assignedLabels?.includes(label.id) ?? false}
        onClick={(e) =>
          setUpdatedData(
            updateLabelsData({
              id: e.data,
              value: e.selected,
              assignedLabels: updatedData
            })
          )
        }
      />
    </div>
  ));

  return <>{buttons.length === 0 ? noRecords : buttons}</>;
};

export default memo(ButtonList);
